import { com } from '@eidu/web'
import resourceBaseUrl from './baseUrl'
import createResourceClient = com.eidu.resources.createResourceClient
import JsResourceClient = com.eidu.resources.JsResourceClient
import NotFound = com.eidu.resources.ResourceClientException.NotFound

let client: JsResourceClient | undefined

const resourceClient = (): JsResourceClient =>
  (client ??= createResourceClient(
    'entity-console',
    import.meta.env.VITE_APP_VERSION ?? '0.0.0',
    `${resourceBaseUrl}/`
  ))

export const getResourceBytes = async (key: string): Promise<Uint8Array | null> => {
  try {
    const response = await resourceClient().get(key)
    return response.body
  } catch (e) {
    if (e instanceof NotFound) return null
    throw e
  }
}

export const getResourceText = async (key: string): Promise<string | null> => {
  const bytes = await getResourceBytes(key)
  return bytes === null ? null : new TextDecoder().decode(bytes)
}

export const requireResourceText = async (key: string): Promise<string> => {
  const text = await getResourceText(key)
  if (text === null) throw new Error(`Resource not found: ${key}`)
  return text
}

export const putResource = async (key: string, bytes: Uint8Array): Promise<void> => {
  await resourceClient().put(key, bytes)
}
